import { render } from "./Plugin.vue?vue&type=template&id=969ea028&scoped=true"
import script from "./Plugin.vue?vue&type=script&lang=js"
export * from "./Plugin.vue?vue&type=script&lang=js"

import "./custom-links.scss?vue&type=style&index=0&id=969ea028&lang=scss&scoped=true"
import "./custom-plugin.scss?vue&type=style&index=1&id=969ea028&lang=scss&scoped=true"
import "./custom-webhook.scss?vue&type=style&index=2&id=969ea028&lang=scss&scoped=true"
import "./custom-logs.scss?vue&type=style&index=3&id=969ea028&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969ea028"]])

export default __exports__